import { useState } from 'react';
import { Select } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import { useActivateEnvironment, useEnvironments } from '@presentation/hooks/useEnvironments';
import { EnvironmentManagerDrawer } from '@presentation/components/workbench/EnvironmentManagerDrawer';

interface EnvironmentSwitcherProps {
  workspaceId: string;
}

const MANAGE_KEY = '__manage__';
const NO_ENVIRONMENT_KEY = '__none__';

export const EnvironmentSwitcher = ({ workspaceId }: EnvironmentSwitcherProps) => {
  const { data: environments } = useEnvironments(workspaceId);
  const activateEnvironment = useActivateEnvironment(workspaceId);
  const [managerOpen, setManagerOpen] = useState(false);

  const active = environments?.find((environment) => environment.isActive);

  const options = [
    { label: 'No environment', value: NO_ENVIRONMENT_KEY },
    ...(environments ?? []).map((environment) => ({
      label: environment.name,
      value: environment.id,
    })),
    {
      label: (
        <span>
          <SettingOutlined /> Manage environments
        </span>
      ),
      value: MANAGE_KEY,
    },
  ];

  const handleChange = (value: string) => {
    if (value === MANAGE_KEY) {
      setManagerOpen(true);
      return;
    }
    if (value === NO_ENVIRONMENT_KEY) {
      return;
    }
    activateEnvironment.mutate(value);
  };

  return (
    <>
      <Select
        size="small"
        value={active?.id ?? NO_ENVIRONMENT_KEY}
        options={options}
        onChange={handleChange}
        className="w-48"
      />
      <EnvironmentManagerDrawer
        workspaceId={workspaceId}
        open={managerOpen}
        onClose={() => setManagerOpen(false)}
      />
    </>
  );
};
